export const formatDate = (
  date: number | string | Date,
  options?: Intl.DateTimeFormatOptions,
): string => {
  const defaultOptions: Intl.DateTimeFormatOptions = {
    dateStyle: "long",
  };
  try {
    return new Intl.DateTimeFormat(
      "ru-RU",
      options ? options : defaultOptions,
    ).format(new Date(date));
  } catch (error) {
    console.error(error);
    return "";
  }
};
